import Image from "@atoms/Image";
import Text from "@atoms/Text";
import { staticAppDownloadLink, mobileDeviceTypes } from "@helpers/constants";
import texts from '@molecules/Footer/V2/en.json';
import { Button } from "@ui/atoms/design-system";
import React, { useEffect, useState } from "react";
import DownloadAppQrCode from "@molecules/Footer/V2/DownloadAppQrCode";
import { getMobileOS } from "@helpers/utils";
import { triggerCustomEvent } from "@helpers/miscelleanous";
import useQrValue from "@hooks/useQrValue";
import { getCookie } from "@helpers/url-utm-handler";

const AppLinks = ({ isLoggedIn = false, className }) => {
    const qrValue = useQrValue();
    const visitUrlCookie = getCookie('visit_url');
    const [showDownloadAppQrCode, setShowDownloadAppQrCode] = useState(null);
    const [mobileOs, setMobileOs] = useState(null);
    const onDownloadClick = ({ show, isIos }) => {
        if (show) {
            triggerCustomEvent(mobileOs === 'ios' ? 'ViewedIosQrFooter' : 'ViewedAndroidQrFooter');
        }
        setShowDownloadAppQrCode(show);
    };

    useEffect(() => {
        setMobileOs(getMobileOS());
    }, []);

    const getMobileDownloadButton = () => {
        return (
            <div
                className={`md:hidden`}>
                <a
                    href={visitUrlCookie ? qrValue : staticAppDownloadLink} target='_blank'
                    id={`gtm-click-app-link-${mobileOs}`}
                    className='cursor-pointer'>
                    <Button
                        prefixComponent={
                            <Image src='/images/footer/download_app.svg' alt="download" />
                        }
                        buttonType="special"
                        buttonSize='extraSmall'
                        buttonText={texts?.Download}
                    />
                </a>
            </div>
        );
    }

    return (
        <div className={`flex flex-row gap-y-3 gap-x-6 items-center ${className}`}>
            <Text content={texts?.DownloadOfficialApp}
                className={`p5-medium text-basicWhite ${!isLoggedIn ? 'hidden' : 'hidden md:block'}`} />
            {/*for mobile */}
            <Text
                className={`p5-medium text-basicWhite ${!isLoggedIn ? 'hidden' : 'md:hidden'}`}
                content={
                    <>{texts?.DownloadOfficialAppMobile1}
                        <br />
                        {texts?.DownloadOfficialAppMobile2}
                    </>
                } />
            {/*for web/tab*/}
            <div className={`hidden md:flex items-center shrink-0 gap-x-4`}>
                <Button
                    prefixComponent={
                        <Image src='/images/footer/download_app.svg' alt="app-store" />
                    }
                    buttonType="special"
                    buttonSize={isLoggedIn ? 'extraSmall' : 'regular'}
                    buttonText={texts?.DownloadTheApp}
                    onClick={() =>
                        onDownloadClick({
                            show: true
                        })
                    }
                />
                {showDownloadAppQrCode && (
                    <DownloadAppQrCode
                        show={showDownloadAppQrCode}
                        onClose={() =>
                            onDownloadClick({
                                qrImage: null
                            })
                        }
                    />
                )}
            </div>

            {/*for mobile */}
            {getMobileDownloadButton()}
        </div>
    );
};

export default AppLinks;